import axios from 'axios'

const ReceivingService = {
  async get (params = {}) {
    return axios.get('prd/purchase-order/receivings', { params })
  },

  async histories (params = {}) {
    return axios.get('prd/reports/purchase-order/receiving-histories', { params })
  },

  async exports (params = {}) {
    return axios.get('prd/exports/purchase-order/receivings', { params })
  },

  async show (id) {
    return axios.get(`prd/purchase-order/receivings/${id}`)
  },

  async post (params = {}) {
    return axios.post('prd/purchase-order/receivings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`prd/purchase-order/receivings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`prd/purchase-order/receivings/${data.id}`, { data })
  }
}

export default ReceivingService
